import { Api } from '@Services/api'
import {
    DirectoryAccount,
    LinkRun,
    LinkStatus,
    ManagedUser,
    MicrosoftLink,
} from './Entity/Identity'

/** Microsoft account linking and user-management listing (contracts/api-identity.md). */
export class IdentityAPI {
    axios = new Api()

    async getManagedUsers(linkStatus?: LinkStatus): Promise<ManagedUser[]> {
        const { data } = await this.axios.get('/identity/users', {
            params: linkStatus ? { linkStatus } : undefined,
        })
        return data
    }

    async startLinkRun(mode: 'dry-run' | 'execute'): Promise<LinkRun> {
        const { data } = await this.axios.post('/identity/link-runs', { mode })
        return data
    }

    async getLinkRuns(limit = 20): Promise<LinkRun[]> {
        const { data } = await this.axios.get('/identity/link-runs', {
            params: { limit },
        })
        return data
    }

    async getLinkRun(runId: string): Promise<LinkRun> {
        const { data } = await this.axios.get(`/identity/link-runs/${runId}`)
        return data
    }

    async runDirectorySync(): Promise<LinkRun> {
        const { data } = await this.axios.post('/identity/directory-sync/manual')
        return data
    }

    async searchDirectory(search: string): Promise<DirectoryAccount[]> {
        const { data } = await this.axios.get('/identity/microsoft-directory', {
            params: { search },
        })
        return data
    }

    async linkMicrosoft(
        uid: string,
        msId: string
    ): Promise<{ uid: string; microsoft: MicrosoftLink }> {
        const { data } = await this.axios.post(`/user/${uid}/microsoft-link`, {
            msId,
        })
        return data
    }

    async unlinkMicrosoft(uid: string): Promise<void> {
        await this.axios.delete(`/user/${uid}/microsoft-link`)
    }

    async setPasswordException(
        uid: string,
        allowed: boolean,
        reason?: string
    ): Promise<void> {
        await this.axios.put(`/user/${uid}/password-exception`, {
            allowed,
            reason,
        })
    }
}

export const identityAPI = new IdentityAPI()
